module.exports = __webpack_public_path__ + "static/media/party.00f4da33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Services/party.jpg
// module id = 84
// module chunks = 0